"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.FileCSVOutlineSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var innerSvg = '<path d="M28,13H27V9.8431a2,2,0,0,0-.5836-1.4121L20.5916,2.588A2,2,0,0,0,19.1752,2H7A2,2,0,0,0,5,4v9H4a2.0059,2.0059,0,0,0-2,2v9a2.0059,2.0059,0,0,0,2,2H5v2a2,2,0,0,0,2,2H25a2,2,0,0,0,2-2V26h1a2.0059,2.0059,0,0,0,2-2V15A2.0059,2.0059,0,0,0,28,13ZM20,4.8274,24.16,9H20ZM7,4H18V9a2.0059,2.0059,0,0,0,2,2h5v2H7ZM25,28H7V26H25Zm3-4H4V15H28Z"/><path d="M9.8418,22.3008c1.4932,0,2.3408-.8711,2.3408-1.84v-.1172H10.9863a1.0043,1.0043,0,0,1-1.123,1.0079c-.7569,0-1.2393-.4805-1.2393-1.5079v-.6015c0-1.0235.4864-1.5274,1.2315-1.5274A1.0472,1.0472,0,0,1,10.9863,18.77h1.1963v-.1133c0-1.0312-.8818-1.8906-2.3359-1.8906a2.274,2.274,0,0,0-2.4873,2.4727V19.84A2.26,2.26,0,0,0,9.8418,22.3008Z"/><path d="M15.751,21.4141c-.7442,0-1.1358-.3516-1.17-.7461H13.3848c.0175.7539.5761,1.6328,2.3066,1.6328,1.4541,0,2.3535-.6446,2.3535-1.6914,0-.9688-.7275-1.3477-1.5879-1.5157l-.8906-.18c-.5254-.0977-.8008-.3047-.8008-.6133,0-.41.375-.668.9776-.668.68,0,1.0195.3477,1.05.7227h1.1611c-.0127-.9414-.8945-1.5977-2.207-1.5977-1.2432,0-2.2246.582-2.2246,1.6289,0,.9063.6884,1.3281,1.5146,1.4883l.8818.1836c.5938.1211.8956.2969.8956.66C16.8145,21.1328,16.4443,21.4141,15.751,21.4141Z"/><polygon points="22.458 22.199 24.377 16.867 22.995 16.867 21.756 20.945 21.705 20.945 20.448 16.867 19.007 16.867 20.938 22.199 22.458 22.199"/>';
var FileCSVOutlineSVG = function FileCSVOutlineSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
exports.FileCSVOutlineSVG = FileCSVOutlineSVG;
FileCSVOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(FileCSVOutlineSVG);
exports.default = _default;